module.exports = __webpack_public_path__ + "static/img/C4D0026.a56c2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0026.jpg
// module id = p0Vq
// module chunks = 0